import { Component } from 'src/utils';
import newOrderImg from './../../../images/new-order.png';
import recentOrderImg from './../../../images/recent-order.png';
import favoriteImg from './../../../images/favorites.png';
import homeArrow from './../../../images/home-arrow.png';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import dscImg from './../../../images/DSC.png';
import subHeaderImg from './../../../images/banner-image.jpg';
import template from './category.html';
import logo from './../../../images/logo-s.png';
import dscCard from './../../../images/WBU-DSC-card.jpg';

@Component({
  controllerAs: 'category',
  template
})

export default class Category {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'authService',
    'orderService',
    '$interval',
      '$rootScope',
      '$timeout',
      '$stateParams',
      '$window',
      'APP',
      '$location','ngMeta', '$uibModal'
  ];

  constructor($scope, $ngRedux, $state, $auth, $order,$interval,$rootScope,$timeout, $stateParams, $window, APP, $location, ngMeta, $uibModal) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$state = $state;
    this.homeArrow = homeArrow;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.newOrderImg = newOrderImg;
    this.recentOrderImg = recentOrderImg;
    this.favoriteImg = favoriteImg;
    this.dscImg = dscImg;
    this.$timeout = $timeout;
    this.$stateParams = $stateParams;
    this.$uibModal = $uibModal;
    this.$auth = $auth;
    this.$order = $order;
    this.subHeaderImg = subHeaderImg;
    this.logo = logo;
    this.dscCard = dscCard;
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.APP = APP;
    this.$location= $location;
    this.ngMeta = ngMeta;
    this.isMiscelleneousCategory = 4;
    // this.testPopup2();
    if(this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      // this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '');
      this.canUrl = this.$location.$$absUrl.replace(this.$location.$$url, '')+'/' +this.$stateParams.storeName;
      
    } 
    else{
      this.canUrl = this.$location.$$absUrl;
    }
    // $order.getGiftCards();
    console.log("this.canUrl.category : ",this.canUrl);
    this.ngMeta.setTag('canUrl',this.canUrl);
    this.$interval = $interval;
    $rootScope.$on('rotateBanner', () => {
      console.log("Banner will rotate");
      this.promoSlider();
    });
    $rootScope.$on('rotateMobileBanner', () => {
      console.log("Mobile Banner will rotate - Code commented now. Will be used in next release");
      this.mobilePromoSlider();
    });
    this.$window.document.title = this.APP.ORDER.ORDER_URL.siteTitle;

    // this.testPopup1();
    
    $scope.$on('$destroy', () => {
      this.$interval.cancel(this.promoSlideInterval);
      this.$interval.cancel(this.mobilePromoSlideInterval);
      disconnect();
    });
  }


  mapState(state) {
    console.log("state.order.tiles",state.order.tiles);
    return {
      profile: state.auth.profile,
      list: state.order.categories,
      tiles: state.order.tiles,
      giftCards : state.order.giftCards
    };
  }
  goToSavingsClub() {
    // this.closeSideNav();
    this.$state.go('savings-club', {'storeName': this.$auth.getGuestStoreDetail().storeName});

  }

  getCarousalSetting() {
    var carousalHeight = document.getElementById('carousel-item-bar').clientHeight;
    carousalHeight = 340;
    // console.log('carousalHeight',carousalHeight);
    this.settings ={};
    if (window.innerWidth < 1367 ) {
        var img =  2000 + "px " + carousalHeight + "px";
      this.settings = {"background-size" : img};
      return this.settings;
    }
    else {
     this.settings = {"background-size" : "2000px 340px"};
      return this.settings;
    }
    
  }
  getCarousalSettingMob() {
    var carousalHeight = document.getElementById('carousel-item-bar-mob').clientHeight;
    carousalHeight = 340;
    // console.log('carousalHeight',carousalHeight);
    this.settings ={};
    if (window.innerWidth < 1367 ) {
        var img =  2000 + "px " + carousalHeight + "px";
      this.settings = {"background-size" : img};
      return this.settings;
    }
    else {
     this.settings = {"background-size" : "2000px 340px"};
      return this.settings;
    }
    
  }

  goToNextState(item) {
    let storeName = '';
    if(this.$stateParams.storeName) {
      storeName = this.$stateParams.storeName;
    }
    else {
      if(this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
       storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    // let storeName =  false;
    if (storeName) {
      if(this.isMiscellaneousCategory(item)){
        this.goToGiftPage(storeName);
      } else {
          if (item.category.name === item.subCategoryList[0].name && item.subCategoryList.length == 1 ) {
            this.$state.go('browse-product', {
              categoryId: item.category.prettyUrl,
              subCategoryId: item.subCategoryList[0].prettyUrl,
              storeName:storeName
            });
          }
          else {
            this.$state.go('browse-sub-category', {categoryId: item.category.prettyUrl, storeName: storeName});
          } 
        }
    }
    else {
      if(this.isMiscellaneousCategory(item)){
        this.goToGiftPage(this.$auth.getGuestStoreDetail().storeName);
      } else {
        if (item.category.name === item.subCategoryList[0].name && item.subCategoryList.length == 1) {
          this.$state.go('browse-product', {
            categoryId: item.category.prettyUrl,
            subCategoryId: item.subCategoryList[0].prettyUrl,
            storeName: this.$auth.getGuestStoreDetail().storeName
          });
        } else {
          // console.log('sc',item.category.id);
          this.$state.go('browse-sub-category', {
            categoryId: item.category.prettyUrl , storeName: 'shop'
          });
        }
      }
    }
  }

  goToNextTile(item) {
    let storeName = '';
    if(this.$stateParams.storeName) {
      storeName = this.$stateParams.storeName;
    }
    else {
      if(this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
       storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }

    if(storeName==null || !storeName) {
      storeName = 'shop'; 
    }

    if (storeName) { 
          if (item.type == this.APP.ORDER.TILES_TYPE.category) {
            if(this.isMiscellaneousCategory(item)) {
              if(storeName=="shop") {
                this.goToGiftPage(this.$auth.getGuestStoreDetail().storeName);
              } else {
                this.goToGiftPage(storeName);
              }
             
            } else{
              this.$state.go('browse-sub-category', 
                {categoryId: item.category.prettyUrl, storeName: storeName}
              );
            }
          } else if (item.type == this.APP.ORDER.TILES_TYPE.subcategory) {
            console.log("item.subcat--",item);
            this.$state.go('browse-product', {
              categoryId: item.category.prettyUrl,
              subCategoryId: item.subCategory.prettyUrl,
              storeName:storeName
            });
          }
          else {
            this.$state.go('browse-sub-category', {categoryId: item.category.prettyUrl, storeName: storeName});
          }  
      }
  }


  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  getBackgroundTitle(category) {
    if (category.alt) {
      return category.alt;
    }
    else {
      return 'Wild Birds Unlimited';
    }
  }

  getBackgroundStyle(category) {
    if (window.innerWidth < 544) {
      return category.smallImageUrl;
    }
    else if (window.innerWidth < 768) {
      return category.largeImageUrl;
    }
    else {
      return category.largeImageUrl;
    }
  }

  getBackgroundTyleStyle(tile) {
    if (window.innerWidth < 544) {
      return tile.smallImageUrl;
    }
    else if (window.innerWidth < 768) {
      return tile.largeImageUrl;
    }
    else {
      return tile.largeImageUrl;
    }
  }

  syncedToday() {
    let syncDate = new Date(this.profile.customer.lastSyncDateTime);
    let currentDate = new Date();
    return syncDate.getDate() === currentDate.getDate();
  }

  isDscMember() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() <= new Date(this.profile.customer.dscExpireDate);
  }

  isDscButExpired() {
    if (!this.profile.customer) return false;
    return this.profile.customer.dscId === 'C' && new Date() > new Date(this.profile.customer.dscExpireDate);
  }
  activePromo(activeindex) {
  if(this.$rootScope.promo) {
    this.$interval.cancel(this.promoSlideInterval);
    this.$rootScope.promo.promoImages.forEach((promo,index) => {
      // console.log(index);
      promo.active = false;
    // console.log(index);
    });
    this.$rootScope.promo.promoImages[activeindex].active = true;
    this.promoSlider();
  }
  }

  promoSlider() {
    if( this.$rootScope.promo) {
    return this.promoSlideInterval =  this.$interval(() => {
          var activeIndex = null;
    this.$rootScope.promo.promoImages.forEach((promo,index) => {
      if(promo.active) {
      activeIndex = index;
    }
  });
    var nextIndex = (this.$rootScope.promo.promoImages.length-1 == activeIndex) ? 0 : activeIndex + 1;
    this.$rootScope.promo.promoImages[activeIndex].active = false;
    this.$rootScope.promo.promoImages[nextIndex].active = true;

  },10000);
  } }


  activeMobilePromo(activeindex) {
    if(this.$rootScope.promo) {
      this.$interval.cancel(this.mobilePromoSlideInterval);
      this.$rootScope.promo.mobilePromoImages.forEach((promo,index) => {
        // console.log(index);
        promo.active = false;
      // console.log(index);
      });
      this.$rootScope.promo.mobilePromoImages[activeindex].active = true;
      this.mobilePromoSlider();
    }
    }


  isMobileDevice() {
    return this.$auth.isMobileLandscapeDevice();
  }
  mobilePromoSlider() {
    if( this.$rootScope.promo) {
      if(this.$rootScope.promo.mobilePromoImages!= null && this.$rootScope.promo.mobilePromoImages.length>0){
        return this.mobilePromoSlideInterval =  this.$interval(() => {
          var activeIndex = null;
            this.$rootScope.promo.mobilePromoImages.forEach((promo,index) => {
              if(promo.active) {
              activeIndex = index;
            }
          });
            var nextIndex = (this.$rootScope.promo.mobilePromoImages.length-1 == activeIndex) ? 0 : activeIndex + 1;
            this.$rootScope.promo.mobilePromoImages[activeIndex].active = false;
            this.$rootScope.promo.mobilePromoImages[nextIndex].active = true;
          },10000);
      }
    } 
  }
  
  isIpad() {
    return ( this.$window.innerWidth < 1248 && this.$window.innerWidth > 767 );
  }

  isMiscellaneousCategory(item){
    if(item){
      if(item.category.id === this.isMiscelleneousCategory){
        return true;
      } else {
        return false;
      }
    }
  }

  goToGiftPage(store) {
    this.$state.go('gift-card', {'storeName': store});
  }

  testPopup1() {
    var $ctrl = this;
    this.$uibModal.open({
      size: 'sm',
      backdrop: 'static',
      keyboard: false,
      template: `<div class="modal-header modalheaderbg btn-primary"><h5><span>{{registerPopUp?"Would you like to register?":"Interested in our products!"}}</span></h5></div>
      <div ng-if="registerPopUp">
          <div class="modal-footer login_redirect_modal login_redirect_modal_footer bg-color bo-tp-o" >
            <button class="btn btn-primary m-l-1" type="button" ng-click="cancelRegisterPopUp()" >No</button>
            <button class="btn btn-primary m-l-1" type="button" ng-click="okForRegister()">Yes</button>
          </div>
        </div>
        <div ng-if="marketingPopUp">
          <div class="form-group.height" style="padding: 15px;">
              <input type="checkbox" name="agreement" ng-model="agreement" class="form-control text-xs-left d-inline"
                style="width: auto;" required /> Receive important information about our products.
          </div>
          <div class="modal-footer login_redirect_modal login_redirect_modal_footer bg-color bo-tp-o" >
            <button class="btn btn-primary m-l-1" type="button" ng-click="cancelMarketingPopUp()" >No</button>
            <button class="btn btn-primary m-l-1" type="button" ng-click="okForMarketing()" ng-disabled="!agreement">Yes</button>
          </div>
        </div>`,
      controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService',
        function ($rootScope, $scope, $uibModalInstance, $auth) {
          $scope.registerPopUp = true;
          $scope.marketingPopUp = false;
          $scope.agreement = false;
          $scope.okForRegister = () => {
            $ctrl.$state.go('signup', {
              storeName: 'indianapolis'
            });
            $uibModalInstance.close();
          };
          $scope.cancelRegisterPopUp = () => {
            $scope.marketingPopUp = true;
            $scope.registerPopUp = false;
          };
          $scope.cancelMarketingPopUp = () => {
            $uibModalInstance.close();
          };
          $scope.okForMarketing = () => {
            $uibModalInstance.close();
            $ctrl.doGuestOptIn();
          };
        }
      ]
    });
  }


  testPopup2() {
    var $ctrl = this;
    this.$uibModal.open({
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      template: `
                <div class="modal-body"><a class="close" href="#" ng-click="cancelMarketingPopUp()">&times;</a>
                    <div class="d-flex flex-column gap-3" style="margin:10px">
                        <div class="py-2" style="margin-bottom:3px;">
                          <strong style="font-size: 18px;">Register an account today!*</strong>
                          <br />
                          &#x25CF Keep your order history
                          <br />
                          &#x25CF Reorder with ease
                          <br />
                          &#x25CF Enjoy exclusive offers
                          <br />
                          <br />
                          *Already a Daily Savings Club Member? Register with the same email you use in-store to access your member savings online instantly.
                          <br />
                          <button class="btn btn-primary btn-block" ng-click="okForRegister()">Register NOW!</button>
                        </div>

                        <div class="py-2" style="margin-bottom:3px; margin-top:10%">
                          <strong style="font-size: 18px;">Stay Connected!</strong>
                          <br />
                          &#x25CF Join our email community and never miss what’s new.
                          <br />
                          &#x25CF Receive helpful bird-feeding tips and seasonal savvy advice.
                          <br />
                          &#x25CF Eligible for special offers from your local store.
                          <br />
                          <button class="btn btn-primary btn-block ng-click="okForMarketing()">Yes, Sign Me Up!</button>
                        </div> 
                        
                        
                        <div class="py-2" style="margin-bottom:3px; margin-top:10%">
                          <strong style="font-size: 18px;">Dismiss Option</strong>
                          
                          <button class="btn btn-primary btn-block ng-click="cancelMarketingPopUp()">Maybe Later!</button>
                        </div>


                      </div>
                </div>
          `,
      controller: ['$rootScope', '$scope', '$uibModalInstance', 'authService',
        function ($rootScope, $scope, $uibModalInstance, $auth) {
          $scope.agreement = false;
          $scope.okForRegister = () => {
            $ctrl.$state.go('signup', {
              storeName: 'indianapolis'
            });
            $uibModalInstance.close();
          };
          
          $scope.okForMarketing = () => {
            $ctrl.removeUserDetailsFromSession();
            $uibModalInstance.close();
            $ctrl.doGuestOptIn();
          };

          $scope.cancelMarketingPopUp = () => {
            $ctrl.removeUserDetailsFromSession();
            $uibModalInstance.close();
          };
        }
      ]
    });
  
  }


}



// WEBPACK FOOTER //
// ./src/app/order/category/category.js